import { fromJS, merge } from 'immutable';
import { FluxStandardAction, IFlashShower, FlashTypes } from '__utils/type';
import * as Actions from 'constants/actions'

export interface alertState {
    flashState: IFlashShower;
}
const rawState: alertState = {
    flashState:{
        type: FlashTypes.NONE,
        message:''
    }
};

const intialState = fromJS(rawState);

export default function flashReducer (
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type)
    {
        case Actions.SHOW_FLASH_MESSAGE:
            return merge(state, fromJS({ flashState: action.payload }));
        case Actions.HIDE_FLASH_MESSAGE:
            return merge(state, fromJS({ flashState: {} }));
        default:
            return state;
    }
}
